import React, { useContext, useCallback, useState } from 'react';
import { Button } from '@ontruck/orc';
import SetToManualFlowContext, {
  SetToManualFlowContextProvider,
} from 'modules/set-to-manual-flow/context';
import { setSelfChangedData } from 'redux/modules/realtime/effects';
import { useDispatch } from 'react-redux';

import {
  featurePreferenceToggle,
  FLEET_PROCESS_HIDE_QUEUED_ORDERS,
} from 'modules/preferences-manager/preferences';

import { fetchShipperOrder as fetchShipperOrderRequest } from 'redux/modules/shipper-orders/http';

const t = {
  body: 'This order is following the automatic flow.',
  fleet_tab: 'This order should me managed from Fleet tab',
  button: 'Set order to manual',
};

const SetOrderToManual = ({ id }) => {
  const dispatch = useDispatch();
  const [unlocking, setUnlocking] = useState(false);
  const { unlock, openModal, needsManualReasonsModal } = useContext(SetToManualFlowContext);

  const afterSubmit = useCallback(async () => {
    const shipperOrder = await fetchShipperOrderRequest(id);
    dispatch(setSelfChangedData({ model: 'shipperorder', data: shipperOrder }));
  }, [id, dispatch]);

  const handleClick = useCallback(async () => {
    const needsModal = await needsManualReasonsModal(id);
    if (!needsModal) {
      try {
        setUnlocking(true);
        await unlock(id);
        const shipperOrder = await fetchShipperOrderRequest(id);
        dispatch(setSelfChangedData({ model: 'shipperorder', data: shipperOrder }));
      } catch (err) {
        console.error(err);
      } finally {
        setUnlocking(false);
      }
    } else {
      openModal(id, {
        afterSubmit,
      });
    }
  }, [id, dispatch, unlock, openModal, afterSubmit, needsManualReasonsModal]);

  return (
    <div data-testid="SetOrderToManual">
      <div style={{ marginBottom: 16 }}>{t.body}</div>
      {!featurePreferenceToggle(FLEET_PROCESS_HIDE_QUEUED_ORDERS) ? (
        <div>
          <Button onClick={handleClick} disabled={unlocking}>
            {t.button}
          </Button>
        </div>
      ) : (
        <div>{t.fleet_tab}</div>
      )}
    </div>
  );
};

const SetOrderToManualProvider = (props) => {
  return (
    <SetToManualFlowContextProvider>
      <SetOrderToManual {...props} />
    </SetToManualFlowContextProvider>
  );
};

export default SetOrderToManualProvider;
